export default __webpack_public_path__ + "static/media/hristina_m.930bdf1d.jpg";